// Small non-blocking "Remember where you parked?" card. Lives in the bottom-left
// control stack so it never covers the map CTAs.

import React from "react";
import { motion } from "framer-motion";
import { Car, X } from "lucide-react";

export default function ParkingMemoryPrompt({ onSave, onDismiss }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      className="pointer-events-auto w-full max-w-xs rounded-2xl bg-[#0a0a0c]/[0.88] border border-[#ccff00]/25 backdrop-blur-md px-3 py-2.5 shadow-lg"
      data-testid="parking-memory-prompt"
    >
      <div className="flex items-start gap-2">
        <Car className="w-3.5 h-3.5 mt-0.5 text-[#ccff00] shrink-0" />
        <div className="text-[12px] text-zinc-100 leading-snug flex-1">
          Remember where you parked?
        </div>
        <button
          type="button"
          onClick={onDismiss}
          className="w-6 h-6 -mr-1 -mt-1 shrink-0 rounded-full flex items-center justify-center text-zinc-500"
          aria-label="Dismiss parking reminder"
          data-testid="parking-memory-close"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
      <div className="mt-2 flex items-center gap-2">
        <button
          type="button"
          onClick={onSave}
          className="h-8 px-3 rounded-full bg-[#ccff00] text-[#0a0a0c] font-semibold text-[12px] active:scale-95 transition-transform"
          data-testid="parking-memory-save"
        >
          Save parking
        </button>
        <button
          type="button"
          onClick={onDismiss}
          className="h-8 px-3 rounded-full border border-white/15 text-zinc-300 text-[12px]"
          data-testid="parking-memory-notnow"
        >
          Not now
        </button>
      </div>
    </motion.div>
  );
}
